import styled from "styled-components";

import Table from "../../ui/Table";

import { HiMiniPause, HiMiniPlay, HiTrash } from "react-icons/hi2";
import ThemedSkeleton from "../../ui/ThemedSkeleton";
import { useDeleteScheduleQuery } from "./useDeleteScheduleQuery";
import { useEditScheduleQuery } from "./useEditScheduleQuery";
import { Button } from "@/components/ui/button";
import { BiLoaderAlt } from "react-icons/bi";

const Value = styled.div`
  color: var(--gray-600);
`;

function QueryRow({ query, isLoading }) {
  const { isLoading: isDeleting, mutate: deleteQuery } =
    useDeleteScheduleQuery();
  const { isLoading: isEditing, mutate: editQuery } = useEditScheduleQuery();

  if (!isLoading) {
    const { table_id, query_text, frequency, notice_type, active } = query;

    return (
      <Table.Row>
        <Value>{query_text}</Value>
        <Value>{notice_type || "All" }</Value>
        <Value>{frequency}</Value>
        <Button
          className="p-0"
          variant="ghost"
          onClick={() =>
            editQuery({ table_id, query_text, frequency, notice_type, active: !active })
          }
        >
          {isEditing ? (
            <BiLoaderAlt className="animate-spin" />
          ) : active ? (
            <HiMiniPause className="fill-success" />
          ) : (
            <HiMiniPlay />
          )}
        </Button>
        <Button
          className="p-0"
          variant="ghost"
          onClick={() => deleteQuery(table_id)}
        >
          {isDeleting ? (
            <BiLoaderAlt className="animate-spin" />
          ) : (
            <HiTrash className="fill-destructive" />
          )}
        </Button>
      </Table.Row>
    );
  } else {
    return (
      <Table.Row>
        <ThemedSkeleton />
        <ThemedSkeleton />
        <ThemedSkeleton />
        <ThemedSkeleton />
        <ThemedSkeleton />
        <ThemedSkeleton />
      </Table.Row>
    );
  }
}

export default QueryRow;
